import { DocumentPayloadMap } from 'bff'
import { DocumentTemplate } from 'piramid-constants'
import { ComponentType } from 'react'
import Agreement from './templates/agreement'
import OrderReport from './templates/order-report'
import SampleDocument from './templates/sample'

/**
 * Registry de templates de documento.
 *
 * Espeja `packages/email/src/index.tsx`, pero con la relación invertida: allá
 * el componente define el contrato y los props se derivan con
 * `ComponentPropsWithoutRef`; acá el schema Zod de `bff` es la fuente de verdad
 * y el `satisfies` obliga a que el componente conforme.
 *
 * Agregar un documento son tres entradas: `documentTemplates`
 * (piramid-constants), `documentContracts` (bff) y este objeto. TypeScript
 * marca las tres si falta alguna.
 */
export const DocumentTemplates = {
  sample: SampleDocument,
  // Delega en el mapa de variantes por tenant (ver ./templates/order-report).
  order_report: OrderReport,
  // Conformidad: bloques compilados + recuadros de firma con ancla.
  agreement: Agreement,
} satisfies {
  [K in DocumentTemplate]: ComponentType<DocumentPayloadMap[K]>
}

export type DocumentTemplatesType = typeof DocumentTemplates

export const renderDocument = <T extends DocumentTemplate>(
  template: T,
  payload: DocumentPayloadMap[T],
) => {
  // El lookup sobre la unión de componentes no se correlaciona con la unión de
  // payloads; el `satisfies` de arriba ya garantiza la correspondencia.
  const Template = DocumentTemplates[template] as ComponentType<
    DocumentPayloadMap[T]
  >

  return <Template {...payload} />
}
